import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeviceService } from '@shared/services';
import { BREAKPOINT } from '@spartacus/storefront';
import {
  CurrentProfileComponent,
  LogoutFromAllDevicesComponent,
  LogoutFromCurrentDeviceComponent,
  MyAccountNavigationComponent,
} from '../../components';
import { LoyaltyQrCardComponent } from '../../components/current-profile/loyalty-qr-card';

@Component({
  selector: 'sd-my-account-page',
  templateUrl: './my-account-page.component.html',
  styleUrls: ['./my-account-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoyaltyQrCardComponent,
    CurrentProfileComponent,
    MyAccountNavigationComponent,
    LogoutFromCurrentDeviceComponent,
    LogoutFromAllDevicesComponent,
  ],
})
export class MyAccountPageComponent {
  private readonly deviceService = inject(DeviceService);
  protected readonly isTablet = toSignal(this.deviceService.isEqual(BREAKPOINT.md), { initialValue: false });
  protected readonly isMobile = toSignal(this.deviceService.isMobileSmDown$, { initialValue: false });
}
